//
// Copyright (c) 2011-2024 by Bazaarvoice, Inc.
//
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getBrandInstagramId = createSelector(
  (state: ICuralateStore) => state.streams.streamsDrawer,
  (streamsDrawer) => streamsDrawer.brandInstagramId,
);

export const getBrandInstagramUsername = createSelector(
  (state: ICuralateStore) => state.streams.streamsDrawer,
  (streamsDrawer) => streamsDrawer.brandInstagramUsername,
);
